import type {
  AvailabilityEnum,
  MultipleProductCard,
  MultipleProductCardVariant,
  SingularProductCard,
  SingularProductCardVariant,
  VariantType
} from "@shared/graphql.types";

export const toVariantType = (
  variant: MultipleProductCardVariant | SingularProductCardVariant,
  productCard: MultipleProductCard | SingularProductCard
): VariantType => {
  return {
    sku: variant.sku,
    availability: {
      status: variant.availability.inStock
        ? ("inStock" as AvailabilityEnum)
        : ("outOfStock" as AvailabilityEnum),
      // FE does not display a stockCount anywhere so it is safe to do this for now
      stockCount: variant.availability.inStock ? 99999 : 0
    },
    pricing: {
      members: variant.pricing.primary.raw,
      typical: variant.pricing.secondary.raw,
      guest: variant.pricing.secondary.raw
    },
    prices: variant.prices,
    brandName: productCard.brandName ?? "",
    title: productCard.title,
    // FE does not display a stockLimit anywhere so it is safe to do this for now
    stockLimit: variant.availability.inStock ? 99999 : 0,
    visuals: [],
    detailsMedia: {
      id: variant.images?.[0]?.src ?? "",
      src: variant.images?.[0]?.src ?? ""
    }
  };
};
